<template>
  <div class="box6">
    <pageTitle
      title="四大课程亮点&nbsp;&nbsp;匹配企业需求"
      text="100+ 案例巩固和运用技术点，N个线上学员专属公开课"
      titleColor="#3E4F48"
      titColor="#4E5969"
    />
    <scrollBox
      scrollwidth="1.270"
      scrollHeight="0.08"
      scrollColor="#c0ebe1"
      blockwidth="0.32"
      blockColor="#2ebe9c"
      step="17"
    >
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        :style="
          `background-image: url(` +
          require(`../../../assets/coursePage/web/box6/${index + 1}.png`) +
          `)`
        "
      >
        <div class="name">{{ item.name }}</div>
        <div class="heng"></div>
        <div class="txt">{{ item.txt }}</div>
      </div>
      <div class="seat"></div>
    </scrollBox>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import scrollBox from "../common/scrollBox.vue";
export default {
  components: {
    pageTitle,
    scrollBox,
  },
  data() {
    return {
      list: [
        {
          img: require("../../../assets/coursePage/web/box6/1.png"),
          name: "应用型/实用型技术",
          txt: "课程深度调研市场需求，对Vue、小程序课程等进行了升级和优化，内容覆盖Vue2全家桶、Vue3 + TypeScript、原生小程序、React + TypeScript、原生小程序、uni-app等实用技术，满足90%企业对前端工程师的需求。",
        },
        {
          img: require("../../../assets/coursePage/web/box6/1.png"),
          name: "研究院精心打造超大项目库",
          txt: "项目研发团队精心研发，多行业多领域项目覆盖主流行业，项目课程天数占比60%以上。来自某里、某滴、某度等公司的前端工程师给项目带来绝佳实践和众多解决方案。",
        },
        {
          img: require("../../../assets/coursePage/web/box6/1.png"),
          name: "开源贡献老师为课程赋能",
          txt: "课程研发团队有积极参与开源贡献的老师们，有vue开源贡献的周老师，有uni-app开源贡献苏老师，为课程赋能。",
        },
        {
          img: require("../../../assets/coursePage/web/box6/1.png"),
          name: "多场景化高效学习方式",
          txt: "多场景化高效学习方式助力学员短时间掌握实用技术。老师讲法精进，课程清晰明了，教和练相结合，促进学员更快吸收。",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box6 {
  padding: 80px 0 56px;
  width: 100%;

  background: linear-gradient(180deg, #ecfbf1 0%, #ffffff 100%);
  .seat {
    width: 32px;
    flex-shrink: 0;
  }
  .item {
    width: 452px;
    height: 538px;
    border-radius: 16px;
    flex-shrink: 0;
    margin-left: 32px;
    margin: 48px 0 32px 32px;
    /* background: url("../../../assets/coursePage/web/box6/itembgc.png") no-repeat; */
    padding: 64px 44px 0 48px;
    box-sizing: border-box;
    position: relative;
    background-size: cover;
    .name {
      font-size: 28px;

      font-weight: 600;
      color: #1d2129;
      line-height: 44px;
      -webkit-background-clip: text;

      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }
    .heng {
      width: 64px;
      height: 6px;
      background: #2ebe9c;
      border-radius: 3px;
      margin: 16px 0 40px;
    }
    .txt {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
    }
  }
}
</style>
